const b2bAccordion = document.querySelector('.b2b-accordion');

function getCatDiscount() {
  let catDiscount = 0;
  const dropdownList = document.querySelector('.b2b-product__action-area-left .dropdown__list');
  const inputElements = dropdownList.querySelectorAll('input[type="radio"]');
  inputElements.forEach((input) => {
    if (input.checked && input.dataset.catdiscount) {
      catDiscount = input.dataset.catdiscount;
    }
  });

  return catDiscount;
}

// function to store cookies
function setCookie(cName, cValue) {
  const date = new Date();
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${cName}=${cValue};${expires};path=/`;
}

// function to check if cookie exists, if exists return json object, if not return null
// function getCookie(cName) {
//   const name = `${cName}=`;
//   const ca = document.cookie.split(';');
//   for (let i = 0; i < ca.length; i += 1) {
//     let c = ca[i];
//     while (c.charAt(0) === ' ') {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) === 0) {
//       return JSON.parse(c.substring(name.length, c.length));
//     }
//   }
//   return null;
// }

// function to delete cookie
function deleteCookie(cName) {
  document.cookie = `${cName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

if (b2bAccordion) {
  let attrData;
  let length;
  let width;
  let priceEl;
  const normalHardness = 'normal';
  const partnerHardness = 'partnersko';
  const productList = document.querySelector('.b2b-product__list');

  // function get selected category discount

  // check if item in cart, if yes add quantity, else add item to cart
  const checkCartForItem = (cart, item) => {
    const index = cart.findIndex((el) => el.product_id === item.product_id && el.variation_id === item.variation_id);
    if (index !== -1) {
      // eslint-disable-next-line no-param-reassign
      cart[index].quantity += parseInt(item.quantity, 10);
    } else {
      cart.push(item);
    }
    return cart;
  };

  if (productList) {
    const userData = document.querySelector('#user-data');
    const getAllHardnessOptions = (arr, val) => {
      const hardnessArray = [];
      arr.forEach((value, i) => {
        if (
          arr[i].attributes.attribute_length === val.attributes.attribute_length &&
          arr[i].attributes.attribute_width === val.attributes.attribute_width
        ) {
          const hardness = arr[i].attributes.attribute_hardness;
          if (!hardnessArray.includes(hardness)) {
            hardnessArray.push(hardness);
          }
        }
      });
      return hardnessArray;
    };

    const getVariationsIndex = (variations, attr, hardness = attr.attributes.attribute_hardness) =>
      variations.findIndex(
        ({ attributes }) =>
          attributes.attribute_cloth === attr.attributes.attribute_cloth &&
          attributes.attribute_hardness === hardness &&
          attributes.attribute_width === attr.attributes.attribute_width &&
          attributes.attribute_length === attr.attributes.attribute_length,
      );

    const getVariationsIndexWH = (variations, attr) =>
      variations.findIndex(
        ({ attributes }) =>
          attributes.attribute_width === attr.attributes.attribute_width &&
          attributes.attribute_length === attr.attributes.attribute_length,
      );

    const setPrice = (product, variation) => {
      const fullPrice = parseFloat(variation.baseprice);
      const finalPrice = parseFloat(variation.price);
      const quantity = parseFloat(product.querySelector('.select-quantity .dropdown__placeholder-text').innerText);
      let slashedPrice = '';
      if (fullPrice !== finalPrice) {
        slashedPrice = `<s>${getPriceInEuro(fullPrice * quantity)}</s><br>`;
      }
      priceEl.dataset.price = finalPrice.toString();
      priceEl.dataset.slashedprice = fullPrice.toString();
      priceEl.innerHTML = `${slashedPrice}${getPriceInEuro(parseFloat(finalPrice * quantity))}`;
      // eslint-disable-next-line no-param-reassign
      product.dataset.variationid = variation.variation_id;
    };

    const updateCartBadgeNumber = (quantity) => {
      const cartBadge = document.querySelector('.header-main__cart-btn ');
      const cartBadgeNumber = cartBadge.querySelector('.header-main__badge');
      if (cartBadgeNumber) {
        const currentNumber = parseInt(cartBadgeNumber.innerText, 10) || 0;
        cartBadgeNumber.innerText = currentNumber + quantity;
      } else {
        cartBadge.insertAdjacentHTML('beforeend', `<span class="header-main__badge">${quantity}</span>`);
      }
    };

    const productItems = document.querySelector('.b2b-product__list');

    productItems.addEventListener('click', (e) => {
      const productEl = e.target.closest('.b2b-accordion');
      const dropdownEl = e.target.closest('.dropdown');
      const quantityEl = e.target.closest('.select-quantity');
      const dropdownLiEl = e.target.classList.contains('dropdown__list-option');
      const radioButtonEl = e.target.parentElement.classList.contains('b2b-accordion__input-item');
      const addToCartButtonEl = e.target.closest('.b2b-accordion__button');
      let slashedPriceText = '';

      if (productEl) {
        priceEl = productEl.querySelector('.b2b-accordion__price-top');
      }

      // click on dropdown list item
      if (dropdownLiEl) {
        const dropdownPlaceholder = dropdownEl.querySelector('.dropdown__placeholder-text');
        const dataEl = e.target.parentElement.querySelector('input');
        dropdownPlaceholder.innerText = dataEl.dataset.title;

        if (quantityEl) {
          const price = parseFloat(priceEl.dataset.price);
          const slashedPrice = parseFloat(priceEl.dataset.slashedprice);
          const quantity = parseFloat(e.target.innerText);
          if (slashedPrice && slashedPrice !== price) {
            slashedPriceText = `<s>${getPriceInEuro(slashedPrice * quantity)}</s><br>`;
          }
          priceEl.innerHTML = `${slashedPriceText}${getPriceInEuro(parseFloat((price * quantity).toString()))}`;
        } else {
          length = dataEl.dataset.length;
          width = dataEl.dataset.width;
        }
      }

      // click on radio button
      if (radioButtonEl) {
        const selectedSize = productEl.querySelector('.select-size input:checked');
        length = selectedSize.dataset.length;
        width = selectedSize.dataset.width;
      }

      // click filter item (size, hardness, cloth)
      if ((radioButtonEl || dropdownLiEl) && !quantityEl) {
        const variations = JSON.parse(productEl.dataset.variations);
        const selectedHardness = productEl.querySelector('.select-hardness input:checked');
        const selectedCloth = productEl.querySelector('.select-clothes input:checked');
        let index = -1;

        if (selectedHardness && selectedCloth) {
          attrData = {
            attributes: {
              attribute_length: length,
              attribute_width: width,
              attribute_hardness: selectedHardness.dataset.value,
              attribute_cloth: selectedCloth.dataset.value,
            },
          };
          const hardnessOptions = getAllHardnessOptions(variations, attrData);
          const hardnessFilter = productEl.querySelectorAll('.select-hardness input');
          index = getVariationsIndex(variations, attrData);

          if (index === -1) {
            productEl.querySelector(`[data-value="${normalHardness}"]`).checked = true;
            productEl.querySelector(`[data-value="${partnerHardness}"]`).checked = false;
            index = getVariationsIndex(variations, attrData, normalHardness);
          }

          hardnessFilter.forEach((el) => {
            const disabled = hardnessOptions.includes(el.dataset.value);
            el.parentElement.classList.toggle('disabled', !disabled);
          });
        } else {
          attrData = {
            attributes: {
              attribute_length: length,
              attribute_width: width,
            },
          };
          index = getVariationsIndexWH(variations, attrData);
        }

        setPrice(productEl, variations[index]);
      }

      if (addToCartButtonEl) {
        const modal = productEl.querySelector('.b2b-add-to-cart-modal');
        let cookieProducts = getCookie('b2b-cart');
        modal.classList.add('is-open-modal');
        const product = {
          product_id: productEl.dataset.id,
          variation_id: productEl.dataset.variationid,
          quantity: parseFloat(productEl.querySelector('.select-quantity .dropdown__placeholder-text').innerText),
          discount: getCatDiscount(),
        };
        updateCartBadgeNumber(product.quantity);
        if (cookieProducts) {
          cookieProducts = checkCartForItem(JSON.parse(cookieProducts), product);
        } else {
          cookieProducts = [product];
        }
        setCookie('b2b-cart', JSON.stringify(cookieProducts));
      }
    });

    // append filters in accordion product
    const appendHtml = (id, html, variations, variationId) => {
      const product = document.querySelector(`[data-id="${id}"]`);
      product.querySelector('.b2b-accordion__filters').innerHTML = html;
      product.dataset.variations = JSON.stringify(variations).toLowerCase();
      product.dataset.variationid = variationId;
    };

    // ajax get product variations
    const axiosGetProductVariations = (data) => {
      const formDataInput = new FormData();
      formDataInput.append('action', 'getProductVariations');
      formDataInput.append('inputs', JSON.stringify(data));
      axios
        .post(localData.siteURL, formDataInput, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            appendHtml(response.data.data.id, response.data.data.html, response.data.data.variations, response.data.data.variation_id);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };

    // click on accordion
    attachEvent('.b2b-accordion__title', 'click', (ev) => {
      const productData = {};
      const parentElem = ev.target.closest('.b2b-accordion');
      const accContent = parentElem.querySelector('.b2b-accordion__content');
      const catDiscount = getCatDiscount();
      parentElem.classList.toggle('is-open');
      slideToggle(accContent, 300, 'block');

      if (parentElem.classList.contains('is-open')) {
        productData.id = parentElem.dataset.id;
        productData.user_id = userData.dataset.userid;
        productData.user_discount = catDiscount;
        axiosGetProductVariations(productData);
      }
    });

    const openB2BMoreModals = document.querySelectorAll('.open-read-more-modal');
    openB2BMoreModals.forEach((openB2BModal) => {
      openB2BModal.addEventListener('click', () => {
        const parent = openB2BModal.closest('.b2b-accordion');
        const modal = parent.querySelector('.b2b-read-more-modal');

        modal.classList.add('is-open-modal');
      });
    });
  }
}
